<script>
export default {
  name: 'AdminStatusBadge',
  props: {
    status: {
      type: [String, Number],
      required: true,
    },
    map: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'sm',
    },
    dot: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalized() {
      const item = this.map?.[this.status] || {}
      return {
        label: item.label || String(this.status),
        tone: item.tone || 'default',
      }
    },
    chipColor() {
      const toneColorMap = {
        success: 'success',
        warning: 'warning',
        danger: 'error',
        info: 'info',
        default: 'secondary',
      }
      return toneColorMap[this.normalized.tone] || 'secondary'
    },
  },
}
</script>

<template>
  <v-chip
    :size="size"
    :color="chipColor"
    :prepend-icon="dot ? 'mdi-circle-small' : undefined"
    label
    variant="tonal"
  >
    {{ normalized.label }}
  </v-chip>
</template>
